//components
// import CartComponent from './components/CartComponent';
// import Notification from './components/Notification';
// import Back from './components/Back';
// import CardItem: () => import('./components/CardItem') from './components/CardItem: () => import('./components/CardItem')';
// import SaleTag from './components/SaleTag';
// import RatingStar from './components/RatingStar';
// import Heart from './components/Heart: () => import('./components/Heart')';
// import CategorySwiper from './components/CategorySwiper';
// import Swiper from './components/Swiper';
// import Login from './components/Login';
// import Register from './components/Register';
// import AddToCart from './components/AddToCart';
// import MDivider from './components/MDivider';
// import ProductTag from './components/ProductTag';
// import Loader from './components/Loader';
// import InlineLoader from './components/InlineLoader';
// import BackShopPage: () => import('./components/BackShopPage') from './components/BackShopPage: () => import('./components/BackShopPage')';
// import MyPhoneShopTag from './components/MyPhoneShopTag';

// layout components
// import HomeCarousel from './layouts/HomeCarousel';
// import HeaderLayout from './layouts/HeaderLayout';
// import PromoCarousel: () => import('./layouts/PromoCarousel') from './layouts/PromoCarousel: () => import('./layouts/PromoCarousel')';
// import BottomNav from './layouts/BottomNav';
// import SideNav from './layouts/SideNav';
// import SideNavSeller from './layouts/SideNavSeller';
// import MostPopularProducts from './layouts/MostPopularProducts';
// import ItemsOnSale from './layouts/ItemsOnSale';
// import TopBrandSale from './layouts/TopBrandSale';
// import ItemsMightLike from './layouts/ItemsMightLike';
// import HomeButtons from './layouts/HomeButtons';
// import ImageSlideUploader from './layouts/ImageSlideUploader';
// import ProductCondition from './views/ProductManagement/ProductCondition';
// import AddProductDialog from './layouts/AddProductDialog';
// import AddProductRewards from './views/ProductManagement/AddProductRewards';
// import AddProductPackaging from './views/ProductManagement/AddProductPackaging';
// import AddProductShipping from './views/ProductManagement/AddProductShipping';
// import AddProductWholesale from './views/ProductManagement/AddProductWholesale';
// import DialogSideNav from './layouts/DialogSideNav';
// import MemberSocialShare from './layouts/MemberSocialShare';
// import MyAddresses from './layouts/MyAddresses';
// import NewAddress from './layouts/NewAddress';
// import ChooseCourier from './layouts/ChooseCourier';
// import ChoosePaymentMethod from './layouts/ChoosePaymentMethod';
// import ConfirmPlaceOrder from './layouts/ConfirmPlaceOrder';
// import SuccessPlaceOrder from './layouts/SuccessPlaceOrder';
// import SearchResult from './layouts/SearchResult';
// import MyPhoneShopCarousel from './layouts/MyPhoneShopCarousel';
// import MyPhoneShopSales from './layouts/MyPhoneShopSales';
// import MyPhoneShopArrivals from './layouts/MyPhoneShopArrivals';
// import MyPhoneShopProducts from './layouts/MyPhoneShopProducts';
// import MyFavorite from './layouts/MyFavorite';

const Components = {
    HeaderLayout: () => import('./layouts/HeaderLayout'),
    CartComponent: () => import('./components/CartComponent'),
    MDivider: () => import('./components/MDivider'),
    Notification: () => import('./components/Notification'),
    Back: () => import('./components/Back'),
    BackShopPage: () => import('./components/BackShopPage'),
    HomeCarousel: () => import('./layouts/HomeCarousel'),
    PromoCarousel: () => import('./layouts/PromoCarousel'),
    CardItem: () => import('./components/CardItem'),
    SaleTag: () => import('./components/SaleTag'),
    RatingStar: () => import('./components/RatingStar'),
    Heart: () => import('./components/Heart'),
    CategorySwiper: () => import('./components/CategorySwiper'),
    Swiper: () => import('./components/Swiper'),
    BottomNav: () => import('./layouts/BottomNav'),
    SideNav: () => import('./layouts/SideNav'),
    SideNavSeller: () => import('./layouts/SideNavSeller'),
    MostPopularProducts: () => import('./layouts/MostPopularProducts'),
    ItemsOnSale: () => import('./layouts/ItemsOnSale'),
    TopBrandSale: () => import('./layouts/TopBrandSale'),
    ItemsMightLike: () => import('./layouts/ItemsMightLike'),
    Login: () => import('./components/Login'),
    Register: () => import('./components/Register'),
    AddToCart: () => import('./components/AddToCart'),
    HomeButtons: () => import('./layouts/HomeButtons'),
    DialogSideNav: () => import('./layouts/DialogSideNav'),
    ProductTag: () => import('./components/ProductTag'),
    ImageSlideUploader: () => import('./layouts/ImageSlideUploader'),
    ProductCondition: () => import('./views/ProductManagement/ProductCondition'),
    AddProductDialog: () => import('./layouts/AddProductDialog'),
    AddProductRewards: () => import('./views/ProductManagement/AddProductRewards'),
    AddProductPackaging: () => import('./views/ProductManagement/AddProductPackaging'),
    AddProductShipping: () => import('./views/ProductManagement/AddProductShipping'),
    AddProductWholesale : () => import('./views/ProductManagement/AddProductWholesale'),
    MemberSocialShare : () => import('./layouts/MemberSocialShare'),
    Loader : () => import('./components/Loader'),
    MyAddresses : () => import('./layouts/MyAddresses'),
    NewAddress : () => import('./layouts/NewAddress'),
    ChooseCourier : () => import('./layouts/ChooseCourier'),
    ChoosePaymentMethod : () => import('./layouts/ChoosePaymentMethod'),
    ConfirmPlaceOrder : () => import('./layouts/ConfirmPlaceOrder'),
    SuccessPlaceOrder : () => import('./layouts/SuccessPlaceOrder'),
    SearchResult : () => import('./layouts/SearchResult'),
    InlineLoader : () => import('./components/InlineLoader'),
    MyPhoneShopCarousel : () => import('./layouts/MyPhoneShopCarousel'),
    MyPhoneShopSales : () => import('./layouts/MyPhoneShopSales'),
    MyPhoneShopTag : () => import('./components/MyPhoneShopTag'),
    MyPhoneShopArrivals : () => import('./layouts/MyPhoneShopArrivals'),
    MyPhoneShopProducts : () => import('./layouts/MyPhoneShopProducts'),
    MyFavorite: () => import('./layouts/MyFavorite')
};

export default Components;
